module.exports = __webpack_public_path__ + "static/media/vcLogo.10c965df.png";